// frontend/src/components/PostDetailModal.jsx - REEMPLAZAR TODO EL ARCHIVO

import { materialesParaPlataforma, materialPermitido } from '../utils/materialesPlataforma';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import contentService from '../services/contentService';
import usuariosService from '../services/usuariosService';
import { clienteService, proyectoService, presupuestoCostoService, itemPresupuestoCostoService } from '../services/onebaseService';
import kanbanService from '../services/kanbanService';
import authService from '../services/authService';
import CommentsSection from './CommentsSection';
// import TasksSection from './TasksSection';
import TareaModal from '../pages/TareaModal';
import PostPatrocinio from './PostPatrocinio';
import './PostDetailModal.css';
import RichTextEditor from './RichTextEditor';
import PostPreviewPanel from './PostPreviewPanel';

import Loading from './Loading';
// El historial de ediciones del backend no guarda en qué pestaña ocurrió
// el cambio, solo el nombre del campo. Este mapa infiere la pestaña a
// partir del campo editado para poder mostrarla en la tabla de Ediciones.
const FIELD_TAB_LABELS = {
  title: 'Información', platform: 'Información', material_type: 'Información',
  influencer: 'Información', publication_date: 'Información', desarrolla: 'Información',
  creative_idea: 'Workflow', copy: 'Workflow', hashtags: 'Workflow', mentions: 'Workflow',
  post_patrocinado: 'Patrocinio', patrocinio_centro_costo: 'Patrocinio',
  patrocinio_codigo: 'Patrocinio', patrocinio_monto: 'Patrocinio', patrocinio_link: 'Patrocinio',
};
const getFieldTabLabel = (field) => FIELD_TAB_LABELS[field] || 'Información';

// Los campos ricos (Brief, Copy, Idea Creativa) guardan el valor como HTML;
// para la tabla de Ediciones se muestra el texto plano, sin las etiquetas.
const stripHtmlValue = (value) => {
  if (value === null || value === undefined || value === '') return value;
  const str = String(value);
  if (!/<[a-z][\s\S]*>/i.test(str)) return str;
  const tmp = document.createElement('div');
  tmp.innerHTML = str;
  return (tmp.textContent || tmp.innerText || '').trim();
};

const PostDetailModal = ({ postId, onClose, onUpdate, fromEmailLink = false }) => {
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('info');
  const [editMode, setEditMode] = useState({});
  const [formData, setFormData] = useState({});
  const [uploadingMedia, setUploadingMedia] = useState(false);
  const [uploadProgress, setUploadProgress] = useState('');
  const [pendingMediaIds, setPendingMediaIds] = useState([]);
  const [sendingNotification, setSendingNotification] = useState(false);
  const [users, setUsers] = useState([]);
  const [influencers, setInfluencers] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [proyectosFiltrados, setProyectosFiltrados] = useState([]);
  const [desarrollaList, setDesarrollaList] = useState([]);
  const [tableros, setTableros] = useState([]);
  const [showTareaModal, setShowTareaModal] = useState(false);
  const [tareaEditando, setTareaEditando] = useState(null);
  const [toast, setToast] = useState({ visible: false, message: '', type: 'success' });
  const toastTimerRef = React.useRef(null);
  const [approvingKey, setApprovingKey] = useState(null);

  const showToast = (message, type = 'success') => {
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    setToast({ visible: true, message, type });
    toastTimerRef.current = setTimeout(() => setToast(t => ({ ...t, visible: false })), 4000);
  };
  const [tareasDelPost, setTareasDelPost] = useState([]);
  const [loadingTareas, setLoadingTareas] = useState(false);
  const [newComment, setNewComment] = useState({
    type: 'general',
    content: ''
  });

  // Estados para tiempo manual
  const [showManualTimeForm, setShowManualTimeForm] = useState(false);
  const [selectedTaskForTime, setSelectedTaskForTime] = useState(null);
  const [manualTimeForm, setManualTimeForm] = useState({
    fecha: new Date().toISOString().split('T')[0],
    minutos: '',
    notas: ''
  });

  // Nuevos estados para edición de información
  const [editModeInfo, setEditModeInfo] = useState(false);
  const [editModePatrocinio, setEditModePatrocinio] = useState(false);
  const patrocinioRef = React.useRef(null);
  const [infoFormData, setInfoFormData] = useState({});
  const [uploadingInfoAttachment, setUploadingInfoAttachment] = useState(false);
  const [editoresSeleccionados, setEditoresSeleccionados] = useState([]); // 🆕 Editores seleccionados
  const [isManager, setIsManager] = useState(false); // 🆕 Verificar si el usuario es Manager
  const [publishingStatus, setPublishingStatus] = useState(false); // 🆕 Estado para publicar
  const [canApproveCreativeIdea, setCanApproveCreativeIdea] = useState(false); // 🆕 Permiso para aprobar idea creativa
  const [canApproveCopy, setCanApproveCopy] = useState(false); // 🆕 Permiso para aprobar copy
  const [isClientApprover, setIsClientApprover] = useState(false); // 🆕 Grupo "Aprobación Cliente"
  const [lightboxImage, setLightboxImage] = useState(null); // 🆕 Previsualización de imagen
  const [approvingMedia, setApprovingMedia] = useState(null); // { id, action } del media en proceso

  // Estados para presupuesto e items
  const [presupuestosCosto, setPresupuestosCosto] = useState([]);
  const [presupuestosCostoFiltrados, setPresupuestosCostoFiltrados] = useState([]);
  const [itemsPresupuesto, setItemsPresupuesto] = useState([]);
  const [itemsPresupuestoSeleccionados, setItemsPresupuestoSeleccionados] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);
  const [etiquetasDisponibles, setEtiquetasDisponibles] = useState([]);
  const [etiquetasColores, setEtiquetasColores] = useState({});
  const [etiquetaSelectValue, setEtiquetaSelectValue] = useState('');

  useEffect(() => {
    if (postId) {
      loadPostDetail();
      loadUsers();
      loadInfluencers();
      loadPlatforms();
      loadClientes();
      loadProyectos();
      loadDesarrolla();
      loadTableros();
      loadTareasDelPost();
      loadPresupuestosCosto();
      checkUserPermissions();
      usuariosService.getEtiquetasDisponibles()
        .then(res => {
          setEtiquetasDisponibles(Array.isArray(res?.etiquetas) ? res.etiquetas : []);
          setEtiquetasColores(res?.etiquetas_colores || {});
        })
        .catch(() => {});
    }
  }, [postId]);

  // 🆕 Verificar si el usuario tiene el grupo "Managers"
  const checkUserPermissions = () => {
    const user = authService.getUser();
    console.log('🔍 DEBUG - Usuario:', user);
    console.log('🔍 DEBUG - Grupos del usuario:', user?.groups);
    console.log('🔍 DEBUG - ¿Tiene grupo Managers?:', user?.groups?.includes('Managers'));
    if (user && user.groups) {
      const hasManagerGroup = user.groups.includes('Managers');
      setIsManager(hasManagerGroup);
      console.log('🔍 DEBUG - isManager establecido a:', hasManagerGroup);

      // Verificar permisos para aprobar Idea Creativa
      const hasAprobadorIdeaCreativa = user.groups.includes('Aprobadores Idea Creativa');
      setCanApproveCreativeIdea(hasAprobadorIdeaCreativa);
      console.log('🔍 DEBUG - Puede aprobar Idea Creativa:', hasAprobadorIdeaCreativa);

      // Verificar permisos para aprobar Copy
      const hasAprobadorCopy = user.groups.includes('Aprobadores Copy');
      setCanApproveCopy(hasAprobadorCopy);
      console.log('🔍 DEBUG - Puede aprobar Copy:', hasAprobadorCopy);

      // Verificar grupo Aprobación Cliente
      const hasClientApprover = user.groups.includes('Aprobación Cliente');
      setIsClientApprover(hasClientApprover);
      console.log('🔍 DEBUG - Es Aprobación Cliente:', hasClientApprover);
    }
  };

  // Filtrar proyectos según el cliente seleccionado
  useEffect(() => {
    if (infoFormData.cliente) {
      const proyectosPorCliente = proyectos.filter(
        p => p.cliente === parseInt(infoFormData.cliente)
      );
      setProyectosFiltrados(proyectosPorCliente);
    } else {
      setProyectosFiltrados([]);
    }
  }, [infoFormData.cliente, proyectos]);

  // Filtrar presupuestos según el proyecto seleccionado
  useEffect(() => {
    if (infoFormData.proyecto) {
      const presupuestosPorProyecto = presupuestosCosto.filter(
        p => p.proyecto === parseInt(infoFormData.proyecto)
      );
      setPresupuestosCostoFiltrados(presupuestosPorProyecto);
    } else {
      setPresupuestosCostoFiltrados([]);
    }
  }, [infoFormData.proyecto, presupuestosCosto]);

  // Cargar items cuando se selecciona un presupuesto
  useEffect(() => {
    const cargarItemsPresupuesto = async () => {
      if (infoFormData.presupuesto_costo) {
        setLoadingItems(true);
        try {
          const itemsRes = await itemPresupuestoCostoService.getAll({
            presupuesto_costo: infoFormData.presupuesto_costo
          });

          const items = itemsRes.data.results || itemsRes.data || [];

          // Calcular cantidades disponibles
          const itemsConDisponibilidad = items.map(item => {
            const cantidadTotal = parseFloat(item.cantidad) || 0;
            const cantidadEjecutada = parseFloat(item.cantidad_ejecutada) || 0;
            const cantidadDisponible = cantidadTotal - cantidadEjecutada;

            return {
              ...item,
              cantidad_disponible: Math.max(0, cantidadDisponible)
            };
          });

          setItemsPresupuesto(itemsConDisponibilidad);
        } catch (error) {
          console.error('Error cargando items de presupuesto:', error);
          setItemsPresupuesto([]);
        } finally {
          setLoadingItems(false);
        }
      } else {
        setItemsPresupuesto([]);
      }
    };
    cargarItemsPresupuesto();
  }, [infoFormData.presupuesto_costo]);

  const loadClientes = async () => {
    try {
      const response = await clienteService.getAll();
      console.log('🏢 Clientes cargados:', response.data);

      // Manejar diferentes formatos de respuesta
      const clientesData = response.data.results || response.data || [];

      console.log('🏢 Clientes procesados:', clientesData);
      setClientes(Array.isArray(clientesData) ? clientesData : []);
    } catch (error) {
      console.error('Error loading clientes:', error);
      setClientes([]);
    }
  };

  const loadProyectos = async () => {
    try {
      const response = await proyectoService.getAll();
      console.log('📁 Proyectos cargados:', response.data);

      // Manejar diferentes formatos de respuesta
      const proyectosData = response.data.results || response.data || [];

      console.log('📁 Proyectos procesados:', proyectosData);
      setProyectos(Array.isArray(proyectosData) ? proyectosData : []);
    } catch (error) {
      console.error('Error loading proyectos:', error);
      setProyectos([]);
    }
  };

  const loadUsers = async () => {
    try {
      const response = await contentService.getUsers();
      console.log('👥 Usuarios cargados:', response.data);
      setUsers(response.data || []);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };

  const loadInfluencers = async () => {
    try {
      const response = await contentService.getInfluencers();
      console.log('🌟 Influencers cargados:', response.data);

      // Manejar diferentes formatos de respuesta
      let influencersData = [];
      if (Array.isArray(response)) {
        influencersData = response;
      } else if (Array.isArray(response.data)) {
        influencersData = response.data;
      } else if (response.data && Array.isArray(response.data.results)) {
        influencersData = response.data.results;
      }

      console.log('🌟 Influencers procesados:', influencersData);
      setInfluencers(influencersData);
    } catch (error) {
      console.error('Error loading influencers:', error);
    }
  };

  const loadPlatforms = async () => {
    try {
      const response = await contentService.getPlatforms();
      console.log('🌐 Plataformas cargadas:', response.data);

      // Manejar diferentes formatos de respuesta
      const platformsData = response.data.results || response.data || [];

      console.log('🌐 Plataformas procesadas:', platformsData);
      setPlatforms(Array.isArray(platformsData) ? platformsData : []);
    } catch (error) {
      console.error('Error loading platforms:', error);
      setPlatforms([]);
    }
  };

  const loadDesarrolla = async () => {
    try {
      const response = await contentService.getDesarrolla();
      console.log('🔧 Desarrolla cargados:', response.data);

      // Manejar diferentes formatos de respuesta
      const desarrollaData = response.data.results || response.data || [];

      console.log('🔧 Desarrolla procesados:', desarrollaData);
      setDesarrollaList(Array.isArray(desarrollaData) ? desarrollaData : []);
    } catch (error) {
      console.error('Error loading desarrolla:', error);
      setDesarrollaList([]);
    }
  };

  const loadPresupuestosCosto = async () => {
    try {
      const response = await presupuestoCostoService.getAll();
      console.log('💰 Presupuestos costo cargados:', response.data);

      // Manejar diferentes formatos de respuesta
      const presupuestosData = response.data.results || response.data || [];

      console.log('💰 Presupuestos procesados:', presupuestosData);
      setPresupuestosCosto(Array.isArray(presupuestosData) ? presupuestosData : []);
    } catch (error) {
      console.error('Error loading presupuestos costo:', error);
      setPresupuestosCosto([]);
    }
  };

  const loadTableros = async () => {
    try {
      const response = await kanbanService.getTableros();
      console.log('📋 Respuesta tableros:', response);

      // La respuesta puede ser { boards: [...] } o directamente [...]
      let tablerosData = [];
      if (Array.isArray(response)) {
        tablerosData = response;
      } else if (response.boards && Array.isArray(response.boards)) {
        tablerosData = response.boards;
      } else if (response.results && Array.isArray(response.results)) {
        tablerosData = response.results;
      }

      console.log('📋 Tableros data:', tablerosData);

      // Cargar miembros para cada tablero
      const tablerosConMiembros = await Promise.all(
        tablerosData.map(async (tablero) => {
          try {
            const membersResponse = await kanbanService.getMembers(tablero.id);
            console.log(`📋 Miembros del tablero ${tablero.nombre}:`, membersResponse);

            // La respuesta puede tener diferentes formatos
            let membersArray = [];
            if (Array.isArray(membersResponse)) {
              membersArray = membersResponse;
            } else if (membersResponse.members && Array.isArray(membersResponse.members)) {
              membersArray = membersResponse.members;
            }

            return {
              ...tablero,
              members: membersArray
            };
          } catch (error) {
            console.error(`Error loading members for board ${tablero.id}:`, error);
            return {
              ...tablero,
              members: []
            };
          }
        })
      );

      console.log('📋 Tableros con miembros procesados:', tablerosConMiembros);
      setTableros(tablerosConMiembros);
    } catch (error) {
      console.error('Error loading tableros:', error);
      setTableros([]);
    }
  };

  const loadTareasDelPost = async () => {
    try {
      setLoadingTareas(true);
      const response = await kanbanService.getAllTasks({ post_asignado: postId });
      console.log('✅ Tareas Kanban del post cargadas:', response);

      // La respuesta viene con la estructura { success: true, count: X, tasks: [...] }
      const tareasData = response.tasks || response.tareas || response.results || response.data?.results || response.data || [];
      console.log('📋 Tareas procesadas:', tareasData);
      setTareasDelPost(Array.isArray(tareasData) ? tareasData : []);
    } catch (error) {
      console.error('Error loading tareas kanban del post:', error);
      setTareasDelPost([]);
    } finally {
      setLoadingTareas(false);
    }
  };

  const loadPostDetail = async ({ silent = false } = {}) => {
    try {
      if (!silent) setLoading(true);
      // Si viene de un enlace de email, usar el endpoint especial que cambia la cuenta automáticamente
      const response = fromEmailLink
        ? await contentService.getPostFromEmailLink(postId)
        : await contentService.getPost(postId);
      setPostData(response.data);
      setFormData({
        creative_idea: response.data.creative_idea || '',
        copy: response.data.copy || '',
        hashtags: response.data.hashtags || '',
        mentions: response.data.mentions || '',
      });

      // Nuevos datos para información editable
      console.log('📋 Influencer del post:', response.data.influencer);
      console.log('📋 Influencer_data:', response.data.influencer_data);

      // Asegurarse de que las fechas estén en el formato correcto para los inputs
      const pubDate = response.data.publication_date || '';
      const pubTime = response.data.publication_time || '';
      const valDate = response.data.validation_date || '';

      setInfoFormData({
        title: response.data.title || '',
        brief: response.data.brief || '',
        brief_objectives: response.data.brief_objectives || '',
        brief_target_audience: response.data.brief_target_audience || '',
        brief_key_messages: response.data.brief_key_messages || '',
        publication_date: pubDate,
        publication_time: pubTime,
        validation_date: valDate,
        material_type: response.data.material_type || '',
        platform: response.data.platform ? String(response.data.platform) : '',
        influencer: response.data.influencer ? String(response.data.influencer) : '',
        desarrolla: response.data.desarrolla ? String(response.data.desarrolla) : '',
        cliente: response.data.cliente ? String(response.data.cliente) : '',
        proyecto: response.data.proyecto ? String(response.data.proyecto) : '',
        presupuesto_costo: response.data.presupuesto_costo ? String(response.data.presupuesto_costo) : '',
        etiqueta: response.data.etiqueta || '',
        etiqueta_color: response.data.etiqueta_color || '#3B82F6',
      });
      // Inicializar el select de etiqueta con el valor actual del post
      setEtiquetaSelectValue(response.data.etiqueta || '');

      // 🆕 Inicializar editores seleccionados
      if (response.data.editores_data && Array.isArray(response.data.editores_data)) {
        setEditoresSeleccionados(response.data.editores_data.map(e => e.id));
      }

      // 🆕 Inicializar items presupuestarios
      if (response.data.items_presupuesto_data && Array.isArray(response.data.items_presupuesto_data)) {
        setItemsPresupuestoSeleccionados(
          response.data.items_presupuesto_data.map(item => ({
            item_presupuesto: String(item.item_presupuesto),
            cantidad_ejecutada: String(item.cantidad_ejecutada)
          }))
        );
      }
    } catch (error) {
      console.error('Error loading post:', error);
      // Si es error de autenticación, redirigir a login
      if (error.response?.status === 401) {
        navigate(`/login?next=${encodeURIComponent(`/view-post/${postId}`)}`);
      } else if (error.response?.status === 403) {
        // Usuario autenticado pero sin permisos
        const errorMessage = error.response?.data?.detail || 'No tienes acceso a este post. Contacta al administrador.';
        alert(errorMessage);
        onClose?.();
      } else if (!silent) {
        alert('Error al cargar el detalle del post');
      }
    } finally {
      if (!silent) setLoading(false);
    }
  };

  const handleEditToggle = (field) => {
    setEditMode({ ...editMode, [field]: !editMode[field] });
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  // Nuevas funciones para manejar edición de información
  const handleInfoEditToggle = () => {
    if (!editModeInfo) {
      // Al abrir el modo de edición, cargar los datos actuales
      setInfoFormData({
        title: postData.title || '',
        brief: postData.brief || '',
        brief_objectives: postData.brief_objectives || '',
        brief_target_audience: postData.brief_target_audience || '',
        brief_key_messages: postData.brief_key_messages || '',
        publication_date: postData.publication_date || '',
        publication_time: postData.publication_time || '',
        validation_date: postData.validation_date || '',
        material_type: postData.material_type || '',
        platform: postData.platform ? String(postData.platform) : '',
        influencer: postData.influencer ? String(postData.influencer) : '',
        desarrolla: postData.desarrolla ? String(postData.desarrolla) : '',
        cliente: postData.cliente ? String(postData.cliente) : '',
        proyecto: postData.proyecto ? String(postData.proyecto) : '',
        presupuesto_costo: postData.presupuesto_costo ? String(postData.presupuesto_costo) : '',
      });

      // Inicializar items presupuestarios si existen
      if (postData.items_presupuesto_data && Array.isArray(postData.items_presupuesto_data)) {
        setItemsPresupuestoSeleccionados(
          postData.items_presupuesto_data.map(item => ({
            item_presupuesto: String(item.item_presupuesto),
            cantidad_ejecutada: String(item.cantidad_ejecutada)
          }))
        );
      } else {
        setItemsPresupuestoSeleccionados([]);
      }
    }
    setEditModeInfo(!editModeInfo);
  };

  const handleInfoInputChange = (field, value) => {
    // Para todos los campos, simplemente actualizar el valor
    setInfoFormData({ ...infoFormData, [field]: value });

    // Si cambia el presupuesto, reiniciar items seleccionados
    if (field === 'presupuesto_costo') {
      setItemsPresupuestoSeleccionados([]);
    }
  };

  // 🆕 Handlers para editores
  const addEditor = (editorId) => {
    if (editorId && !editoresSeleccionados.includes(parseInt(editorId))) {
      setEditoresSeleccionados([...editoresSeleccionados, parseInt(editorId)]);
    }
  };

  const removeEditor = (editorId) => {
    setEditoresSeleccionados(editoresSeleccionados.filter(id => id !== editorId));
  };

  // 🆕 Handlers para items presupuestarios
  const addItemPresupuesto = () => {
    setItemsPresupuestoSeleccionados([
      ...itemsPresupuestoSeleccionados,
      { item_presupuesto: '', cantidad_ejecutada: '' }
    ]);
  };

  const removeItemPresupuesto = (index) => {
    const newItems = itemsPresupuestoSeleccionados.filter((_, i) => i !== index);
    setItemsPresupuestoSeleccionados(newItems);
  };

  const handleItemPresupuestoChange = (index, field, value) => {
    const newItems = [...itemsPresupuestoSeleccionados];
    newItems[index][field] = value;
    setItemsPresupuestoSeleccionados(newItems);
  };

  const handleSubmitInfo = async () => {
    try {
      // 🆕 Incluir solo editores en los datos a enviar
      // Excluir campos de presupuesto: cliente, proyecto, presupuesto_costo, items_presupuesto
      const { cliente, proyecto, presupuesto_costo, publication_time, ...formDataSinPresupuesto } = infoFormData;

      const dataToSend = {
        ...formDataSinPresupuesto,
        editores: editoresSeleccionados
      };

      console.log('📤 Datos a enviar (sin presupuesto):', dataToSend);

      const response = await contentService.updatePostInfo(postId, dataToSend);

      alert(`✅ ${response.data.message || 'Información actualizada exitosamente'}`);

      // Actualizar el estado con los datos devueltos por el backend
      if (response.data.post) {
        setPostData(response.data.post);
      }

      setEditModeInfo(false);
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error updating post info:', error);
      alert(error.response?.data?.error || 'Error al actualizar la información');
    }
  };


  const handleInfoAttachmentUpload = async (files) => {
    if (!files || files.length === 0) return;
    setUploadingInfoAttachment(true);
    try {
      const uploaded = [];
      for (const file of Array.from(files)) {
        const response = await contentService.uploadInfoAttachment(postId, file);
        uploaded.push(response.data.attachment);
      }
      setPostData(prev => ({
        ...prev,
        info_attachments: [...(prev.info_attachments || []), ...uploaded]
      }));
    } catch (error) {
      console.error('Error subiendo adjunto:', error);
      alert(error.response?.data?.error || 'Error al subir el archivo');
    } finally {
      setUploadingInfoAttachment(false);
    }
  };

  const handleInfoAttachmentDelete = async (attachmentId) => {
    if (!window.confirm('¿Eliminar este archivo adjunto?')) return;
    try {
      await contentService.deleteInfoAttachment(attachmentId);
      setPostData(prev => ({
        ...prev,
        info_attachments: (prev.info_attachments || []).filter(a => a.id !== attachmentId)
      }));
    } catch (error) {
      console.error('Error eliminando adjunto:', error);
      alert(error.response?.data?.error || 'Error al eliminar el archivo');
    }
  };

  const handlePatrocinioUpdate = async (patrocinioData) => {
    try {
      const response = await contentService.updatePostInfo(postId, patrocinioData);
      alert(`✅ ${response.data.message || 'Información de patrocinio actualizada exitosamente'}`);

      // Actualizar el estado con los datos devueltos por el backend
      if (response.data.post) {
        setPostData(response.data.post);
      }

      onUpdate?.(postId);
    } catch (error) {
      console.error('Error updating patrocinio:', error);
      alert(error.response?.data?.error || 'Error al actualizar información de patrocinio');
    }
  };

  const handleDeletePost = async () => {
    // Confirmar eliminación
    if (!window.confirm('¿Estás seguro de que deseas eliminar este post? Esta acción cambiará su estado a "Eliminado".')) {
      return;
    }

    try {
      console.log('🗑️ Eliminando post con ID:', postId);

      // Cambiar el estado del post a 'eliminado'
      const response = await contentService.updatePostInfo(postId, { status: 'eliminado' });

      alert('✅ Post eliminado exitosamente');

      // Actualizar el estado del post
      if (response.data.post) {
        setPostData(response.data.post);
      }

      // Notificar a los componentes padre que se actualizó el post
      onUpdate?.(postId);

      // Cerrar el modal después de 500ms
      setTimeout(() => {
        onClose?.();
      }, 500);
    } catch (error) {
      console.error('Error deleting post:', error);
      alert(error.response?.data?.error || 'Error al eliminar el post');
    }
  };

  // 🆕 Handler para cambiar el estado a publicado
  const handlePublishStatus = async () => {
    if (!window.confirm('¿Estás seguro de cambiar el estado del post a "Publicado"?')) {
      return;
    }

    setPublishingStatus(true);
    try {
      // Solo cambiar el estado a 'published' sin publicar en Instagram
      const response = await contentService.updatePost(postId, { status: 'published' });
      console.log('✅ Respuesta de cambio de estado:', response.data);
      alert('✅ Estado del post actualizado a publicado!');

      // Actualizar el estado del post en el modal
      if (response.data) {
        await loadPostDetail();
      }

      // Notificar a los componentes padre que se actualizó el post
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error al cambiar estado del post:', error);
      const errorMsg = error.response?.data?.error || 'Error al cambiar el estado del post. Por favor, intenta de nuevo.';
      alert(`❌ ${errorMsg}`);
    } finally {
      setPublishingStatus(false);
    }
  };

  const handleSaveTarea = async (tareaData) => {
    try {
      if (tareaEditando) {
        // Editar tarea existente de Kanban
        console.log('📝 Actualizando tarea ID:', tareaEditando.id, 'Datos:', tareaData);
        await kanbanService.updateTask(tareaEditando.id, tareaData);
        alert('✅ Tarea actualizada exitosamente');

        // 🆕 Notificar al Kanban que se actualizó una tarea
        window.dispatchEvent(new CustomEvent('tareaActualizada', {
          detail: { tareaId: tareaEditando.id, tareaData }
        }));
      } else {
        // Crear nueva tarea de Kanban - requiere tablero
        if (!tareaData.tablero) {
          alert('❌ Debes seleccionar un tablero para crear la tarea');
          throw new Error('Tablero requerido');
        }
        const response = await kanbanService.createTask(tareaData.tablero, tareaData);
        alert('✅ Tarea creada exitosamente');

        // 🆕 Notificar al Kanban que se creó una nueva tarea
        window.dispatchEvent(new CustomEvent('tareaCreada', {
          detail: { tareaData: response }
        }));
      }

      setShowTareaModal(false);
      setTareaEditando(null);
      // Recargar las tareas del post
      loadTareasDelPost();
    } catch (error) {
      console.error('Error guardando tarea:', error);
      throw error; // Re-lanzar el error para que TareaModal lo maneje
    }
  };

  // Formatear tiempo en HH:MM:SS
  const formatTime = (seconds) => {
    if (!seconds || seconds === 0) return '00:00:00';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  // Manejar agregar tiempo manual
  const handleAddManualTime = async (e) => {
    e.preventDefault();

    if (!manualTimeForm.minutos || manualTimeForm.minutos <= 0) {
      alert('Por favor ingresa un tiempo válido en minutos');
      return;
    }

    if (!selectedTaskForTime) {
      alert('No hay tarea seleccionada');
      return;
    }

    try {
      await kanbanService.createManualTimeLog({
        tarea: selectedTaskForTime.id,
        fecha: manualTimeForm.fecha,
        minutos: parseInt(manualTimeForm.minutos),
        notas: manualTimeForm.notas
      });

      alert('✅ Tiempo registrado exitosamente');

      // Limpiar formulario
      setManualTimeForm({
        fecha: new Date().toISOString().split('T')[0],
        minutos: '',
        notas: ''
      });
      setShowManualTimeForm(false);
      setSelectedTaskForTime(null);

      // Recargar tareas para actualizar el tiempo total
      loadTareasDelPost();
    } catch (error) {
      console.error('Error al registrar tiempo manual:', error);
      alert('❌ Error al registrar tiempo manual');
    }
  };

  // Manejar eliminación de tarea
  const handleDeleteTarea = async (tareaId) => {
    // Confirmar eliminación
    if (!window.confirm('¿Estás seguro de que deseas eliminar esta tarea?')) {
      return;
    }

    try {
      console.log('🗑️ Eliminando TareaKanban con ID:', tareaId);
      await kanbanService.deleteTask(tareaId);
      alert('✅ Tarea eliminada exitosamente');

      // Recargar las tareas del post
      loadTareasDelPost();
    } catch (error) {
      console.error('Error al eliminar tarea:', error);
      alert(error.response?.data?.error || 'Error al eliminar la tarea');
    }
  };

  // Formatear fecha para input datetime-local
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';

    try {
      // Crear fecha en UTC y convertir a hora local para el input
      const date = new Date(dateString);

      // Ajustar a zona horaria local (Chile)
      const offset = date.getTimezoneOffset() * 60000;
      const localDate = new Date(date.getTime() - offset);

      // Formatear para input datetime-local (YYYY-MM-DDTHH:MM)
      return localDate.toISOString().slice(0, 16);
    } catch (error) {
      console.error('Error formateando fecha:', error);
      return '';
    }
  };

  // ========================================
// ENVIAR IDEA CREATIVA PARA REVISIÓN
// ========================================
  const handleSubmitCreativeIdea = async () => {
    try {
      // Validar que haya contenido
      if (!formData.creative_idea || formData.creative_idea.trim() === '') {
        alert('⚠️ Debes escribir una idea creativa');
        return;
      }

      // Enviar SOLO la idea creativa
      const response = await contentService.submitCreative(postId, {
        creative_idea: formData.creative_idea,
      });

      alert(`✅ ${response.data.message}`);

      // Cerrar modo edición y recargar
      setEditMode({ ...editMode, creative_idea: false });
      loadPostDetail();
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error submitting creative idea:', error);
      const errorMsg = error.response?.data?.error ||
                       error.response?.data?.message ||
                       'Error al enviar la idea creativa';
      alert(`❌ ${errorMsg}`);
    }
  };

  // ========================================
  // ENVIAR COPY PARA REVISIÓN
  // ========================================
  const handleSubmitCopy = async () => {
  try {
    // Validar que haya contenido
    if (!formData.copy || formData.copy.trim() === '') {
      alert('⚠️ Debes escribir el copy');
      return;
    }

    // Enviar SOLO el copy con hashtags y menciones
    const response = await contentService.submitCreative(postId, {
      copy: formData.copy,
      hashtags: formData.hashtags,
      mentions: formData.mentions,
    });

    alert(`✅ ${response.data.message}`);

    // Cerrar modo edición y recargar
    setEditMode({ ...editMode, copy: false });
    loadPostDetail();
    onUpdate?.();
  } catch (error) {
    console.error('Error submitting copy:', error);

    // Manejo especial del error cuando la idea creativa no está aprobada
    if (error.response?.status === 400 && error.response?.data?.pending === 'creative_idea') {
      alert(`⚠️ ${error.response.data.message}\n\nDebes esperar a que la idea creativa sea aprobada antes de enviar el copy.`);
    } else {
      const errorMsg = error.response?.data?.error ||
                       error.response?.data?.message ||
                       'Error al enviar el copy';
      alert(`❌ ${errorMsg}`);
    }
  }
};

  const handleApproval = async (type, action, notes = '') => {
    const approvalKey = `${type}-${action}`;
    setApprovingKey(approvalKey);
    try {
      let response;

      switch (type) {
        case 'creative_idea':
          response = await contentService.approveCreativeIdea(postId, action, notes);
          break;
        case 'copy':
          response = await contentService.approveCopy(postId, action, notes);
          break;
        case 'final':
          response = await contentService.finalApprove(postId, action, notes);
          break;
        case 'client':
          response = await contentService.clientApprove(postId, action, notes);
          break;
        default:
          setApprovingKey(null);
          return;
      }

      showToast(response.data.message || 'Aprobación procesada exitosamente', 'success');
      loadPostDetail();
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error in approval:', error);
      const errorMsg = error.response?.data?.error || error.response?.data?.message || 'Error al procesar la aprobación';
      showToast(errorMsg, 'error');
    } finally {
      setApprovingKey(null);
    }
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const currentOrder = postData.media_files?.length || 0;
    const uploadedIds = [];
    let errorCount = 0;

    try {
      setUploadingMedia(true);

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const isVideo = file.type.startsWith('video/');
        const fileLabel = `${i + 1} de ${files.length}`;

        try {
          if (isVideo) {
            // ── Flujo optimizado: subida directa a Spaces con presigned URL ──
            setUploadProgress(`Preparando ${fileLabel}...`);
            const { data: { presigned_url, public_url } } = await contentService.getPresignedUploadUrl(
              postId, file.name, file.type
            );

            setUploadProgress(`Subiendo ${fileLabel} – 0%`);
            await contentService.uploadToPresignedUrl(presigned_url, file, (pct) => {
              setUploadProgress(`Subiendo ${fileLabel} – ${pct}%`);
            });

            setUploadProgress(`Registrando ${fileLabel}...`);
            const res = await contentService.confirmUpload(
              postId, public_url, file.type, file.size, currentOrder + i, true
            );
            if (res.data?.media_file?.id) {
              uploadedIds.push(res.data.media_file.id);
            }
          } else {
            // ── Flujo original para imágenes (son pequeñas, no vale la pena cambiar) ──
            setUploadProgress(`Subiendo ${fileLabel}...`);
            const formData = new FormData();
            formData.append('file', file);
            formData.append('post_id', postId);
            formData.append('file_type', 'image');
            formData.append('order', currentOrder + i);
            formData.append('skip_notify', 'true');

            const res = await contentService.uploadMedia(postId, formData);
            if (res.data?.media_file?.id) {
              uploadedIds.push(res.data.media_file.id);
            }
          }
        } catch (err) {
          console.error(`Error uploading file ${file.name}:`, err);
          errorCount++;
        }
      }

      if (uploadedIds.length > 0) {
        setPendingMediaIds(prev => [...prev, ...uploadedIds]);
        showToast(`${uploadedIds.length} archivo(s) subido(s)${errorCount > 0 ? ` (${errorCount} con error)` : ''}. Presiona "Enviar a Aprobación" cuando estés listo.`);
      } else {
        showToast('No se pudo subir ningún archivo', 'error');
      }

      loadPostDetail({ silent: true });
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error uploading media:', error);
      showToast('Error al subir archivos', 'error');
    } finally {
      setUploadingMedia(false);
      setUploadProgress('');
      // Reset input para permitir subir los mismos archivos
      event.target.value = '';
    }
  };

  const handleSendToApproval = async () => {
    if (!pendingMediaIds.length) return;

    try {
      setSendingNotification(true);
      await contentService.notifyMediaBatch(postId, pendingMediaIds);
      showToast(`Notificación enviada con ${pendingMediaIds.length} archivo(s) para aprobación`);
      setPendingMediaIds([]);
    } catch (error) {
      console.error('Error sending notification:', error);
      showToast('Error al enviar notificación', 'error');
    } finally {
      setSendingNotification(false);
    }
  };

  const handleMediaApproval = async (mediaId, action) => {
    if (approvingMedia) return; // evitar doble click

    if (action === 'rejected') {
      const notes = prompt('¿Por qué rechazas este archivo? (opcional)');
      if (notes === null) return;
    }

    setApprovingMedia({ id: mediaId, action });
    try {
      const response = action === 'rejected'
        ? await contentService.unapproveMedia(mediaId)
        : await contentService.approveMedia(mediaId);

      // Actualizar el estado del media localmente sin recargar todo el post
      setPostData(prev => ({
        ...prev,
        media_files: prev.media_files.map(m => {
          if (m.id !== mediaId) return m;
          if (action === 'rejected') {
            return { ...m, approved: false, approved_by_name: null, approved_by: null };
          } else {
            return {
              ...m,
              approved: true,
              approved_by_name: response.data.approved_by_name || 'Tú',
              approved_by: response.data.approved_by || 'Tú',
            };
          }
        }),
      }));

      // Si todos los medios fueron revisados, recargar para reflejar el nuevo status del post
      if (response.data.all_reviewed) {
        await loadPostDetail({ silent: true });
      }

      onUpdate?.(postId);
    } catch (error) {
      console.error('Error en aprobación de media:', error);
      alert('Error al procesar la aprobación. Intenta nuevamente.');
    } finally {
      setApprovingMedia(null);
    }
  };

  const handleDeleteMedia = async (mediaId) => {
    if (!window.confirm('¿Estás seguro de eliminar este archivo?')) return;

    try {
      await contentService.deleteMedia(mediaId);
      alert('✅ Archivo eliminado');
      loadPostDetail();
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error deleting media:', error);
      alert('Error al eliminar el archivo');
    }
  };

  const handleAddComment = async () => {
    if (!newComment.content.trim()) {
      alert('⚠️ Por favor escribe un comentario');
      return;
    }

    try {
      await contentService.createComment({
        post: postId,
        comment_type: newComment.type,
        content: newComment.content.trim()
      });

      alert('✅ Comentario publicado');

      // Limpiar formulario
      setNewComment({
        type: 'general',
        content: ''
      });

      // Recargar post
      loadPostDetail();
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error creating comment:', error);
      alert('Error al publicar comentario');
    }
  };

  const handleResolveComment = async (commentId) => {
    try {
      await contentService.resolveComment(commentId);
      alert('✅ Comentario marcado como resuelto');
      loadPostDetail();
      onUpdate?.(postId);
    } catch (error) {
      console.error('Error resolving comment:', error);
      alert('Error al resolver comentario');
    }
  };

  const getCommentTypeLabel = (type) => {
    const labels = {
      general: 'General',
      brief: 'Brief',
      creative_idea: 'Idea Creativa',
      copy: 'Copy',
      content: 'Contenido',
      final: 'Final'
    };
    return labels[type] || type;
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      draft: { label: 'Borrador', color: '#9CA3AF' },
      brief_pending: { label: 'Brief Pendiente', color: '#FCD34D' },
      creative_development: { label: 'En Desarrollo', color: '#60A5FA' },
      creative_review: { label: 'Revisión Creativa', color: '#A78BFA' },
      copy_review: { label: 'Revisión Copy', color: '#F472B6' },
      content_review: { label: 'Revisión Contenido', color: '#FB923C' },
      final_review: { label: 'Revisión Final', color: '#FBBF24' },
      approved: { label: 'Aprobado', color: '#34D399' },
      scheduled: { label: 'Programado', color: '#10B981' },
      published: { label: 'Publicado', color: '#059669' },
      rejected: { label: 'Rechazado', color: '#EF4444' },
      no_publicado: { label: 'No Publicado', color: '#6B7280' }
    };

    const statusInfo = statusMap[status] || { label: status, color: '#6B7280' };
    return (
      <span className="status-badge" style={{ backgroundColor: statusInfo.color }}>
        {statusInfo.label}
      </span>
    );
  };

  // Helper para formatear fechas que vienen del backend sin zona horaria
  const formatDateOnly = (dateString) => {
    if (!dateString) return 'N/A';
    const [year, month, day] = dateString.split('-');
    return new Date(year, month - 1, day).toLocaleDateString('es-CL');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Verificar si todos los medios tienen decisión
  const allMediaReviewed = () => {
    if (!postData?.media_files || postData.media_files.length === 0) {
      return true;
    }
    return postData.media_files.every(media => media.approved_by_name);
  };

  // Verificar si se puede dar aprobación final
  const canGiveFinalApproval = () => {
    const user = authService.getUser();
    const isMasterApprover = user?.groups?.includes('Aprobador Maestro');
    const isDirector = user?.groups?.includes('Directores');
    const isClientApproverGroup = user?.groups?.includes('Aprobación Cliente');

    // Master approvers can ALWAYS approve, regardless of status or prior approvals
    if (isMasterApprover) {
      return true;
    }

    // Directors and "Aprobación Cliente" can approve only when
    // idea + copy + at least one media are approved
    if (isDirector || isClientApproverGroup) {
      const hasApprovedMedia = postData.media_files?.some(media => media.approved) || false;
      return (
        postData.creative_idea_approved &&
        postData.copy_approved &&
        hasApprovedMedia
      );
    }

    return false;
  };


  // Mostrar el modal de inmediato con un spinner mientras carga el detalle
  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div
          className="modal-content detail-modal"
          onClick={(e) => e.stopPropagation()}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}
        >
          <button
            onClick={onClose}
            className="close-btn"
            style={{ position: 'absolute', top: 12, right: 12 }}
            aria-label="Cerrar"
          >
            <i className="bi bi-x-lg"></i>
          </button>
          <Loading fullScreen={false} mensaje="Cargando" />
        </div>
      </div>
    );
  }

  if (!postData) return null;

  return (
    <>
      {/* Toast de notificación inline */}
      {toast.visible && (
        <div className={`detail-toast detail-toast--${toast.type}`}>
          <span>{toast.type === 'success' ? '✅' : '❌'} {toast.message}</span>
          <button className="detail-toast__close" onClick={() => setToast(t => ({ ...t, visible: false }))}>×</button>
        </div>
      )}

      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content detail-modal detail-modal--with-preview" onClick={(e) => e.stopPropagation()}>
        {/* Header + Tabs — mismo bloque verde, ahora a todo el ancho (por
            encima del formulario Y del preview) */}
        <div className="detail-header">
          <div className="detail-header-top">
            <h2>{editModeInfo ? (infoFormData.title || postData.title) : postData.title}</h2>
            <div className="detail-header-actions">
              <button onClick={onClose} className="close-btn"><i className="bi bi-x-lg"></i></button>
            </div>
          </div>
          <div className="detail-tabs">
            <button className={`tab-btn ${activeTab === 'info' ? 'active' : ''}`} onClick={() => setActiveTab('info')} title="Información">
              <i className="bi bi-info-circle tab-icon" /><span className="tab-label">Información</span>
            </button>
            <button className={`tab-btn ${activeTab === 'workflow' ? 'active' : ''}`} onClick={() => setActiveTab('workflow')} title="Workflow">
              <i className="bi bi-kanban tab-icon" /><span className="tab-label">Workflow</span>
            </button>
            <button className={`tab-btn ${activeTab === 'media' ? 'active' : ''}`} onClick={() => setActiveTab('media')} title="Contenido">
              <i className="bi bi-images tab-icon" /><span className="tab-label">Contenido</span>
              {(postData.media_files?.length || 0) > 0 && <span className="tab-count">{postData.media_files.length}</span>}
            </button>
            <button className={`tab-btn ${activeTab === 'comments' ? 'active' : ''}`} onClick={() => setActiveTab('comments')} title="Comentarios">
              <i className="bi bi-chat tab-icon" /><span className="tab-label">Comentarios</span>
              {(postData.comments?.length || 0) > 0 && <span className="tab-count">{postData.comments.length}</span>}
            </button>
            <button className={`tab-btn ${activeTab === 'patrocinio' ? 'active' : ''}`} onClick={() => setActiveTab('patrocinio')} title="Patrocinio">
              <i className="bi bi-cash-coin tab-icon" /><span className="tab-label">Patrocinio</span>
            </button>
            <button className={`tab-btn ${activeTab === 'ediciones' ? 'active' : ''}`} onClick={() => setActiveTab('ediciones')} title="Ediciones">
              <i className="bi bi-clock-history tab-icon" /><span className="tab-label">Ediciones</span>
              {(postData.edit_history?.length || 0) > 0 && <span className="tab-count">{postData.edit_history.length}</span>}
            </button>
          </div>
        </div>

        {/* Fila inferior: formulario a la izquierda, preview a la derecha */}
        <div className="detail-modal-body">
        <div className="detail-modal-main">
          {/* Content */}
          <div className="detail-content">
            {activeTab === 'info' && (
              <div className="info-section">
                <>
                  {/* ── Información General ─────────────────────── */}
                  <div className="general-section">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                      <h3 style={{ margin: 0 }}>Información General</h3>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        {/* Editar */}
                        <button
                          onClick={handleInfoEditToggle}
                          disabled={!isManager}
                          title={!isManager ? 'Solo managers pueden editar' : editModeInfo ? 'Cancelar edición' : 'Editar'}
                          className="cal-icon-btn"
                          style={{ opacity: !isManager ? 0.4 : 1, cursor: !isManager ? 'not-allowed' : 'pointer' }}
                        >
                          <i className={editModeInfo ? 'bi bi-x-lg' : 'bi bi-pencil'} />
                        </button>
                        {/* Publicar */}
                        <button
                          onClick={handlePublishStatus}
                          disabled={!isManager || publishingStatus}
                          title={!isManager ? 'Solo managers pueden cambiar el estado' : publishingStatus ? 'Publicando...' : 'Marcar como publicado'}
                          className="cal-icon-btn cal-icon-btn--success"
                          style={{ opacity: (isManager && !publishingStatus) ? 1 : 0.4, cursor: (isManager && !publishingStatus) ? 'pointer' : 'not-allowed' }}
                        >
                          <i className={publishingStatus ? 'bi bi-hourglass-split' : 'bi bi-check-circle'} />
                        </button>
                        {/* Eliminar */}
                        <button
                          onClick={handleDeletePost}
                          disabled={!postData.user_can_delete_post}
                          title={!postData.user_can_delete_post ? 'Sin permiso para eliminar' : 'Eliminar post'}
                          className="cal-icon-btn cal-icon-btn--danger"
                          style={{ opacity: postData.user_can_delete_post ? 1 : 0.4, cursor: postData.user_can_delete_post ? 'pointer' : 'not-allowed' }}
                        >
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </div>
                    <div className="info-grid">

                      <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`} style={{ gridColumn: '1 / -1' }}>
                        <label>Título:</label>
                        {editModeInfo
                          ? <input
                              className="info-edit-field"
                              type="text"
                              value={infoFormData.title}
                              onChange={e => handleInfoInputChange('title', e.target.value)}
                              maxLength={200}
                              placeholder="Título del post"
                            />
                          : <span>{postData.title}</span>
                        }
                      </div>

                      <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`}>
                        <label>Plataforma:</label>
                        {editModeInfo
                          ? <select className="info-edit-field" value={infoFormData.platform} onChange={e => {
                              const nombre = platforms.find(p => String(p.id) === e.target.value)?.name;
                              setInfoFormData(prev => ({
                                ...prev,
                                platform: e.target.value,
                                material_type: materialPermitido(nombre, prev.material_type) ? prev.material_type : ''
                              }));
                            }}>
                              <option value="">Seleccionar</option>
                              {Array.isArray(platforms) && platforms.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                            </select>
                          : <span>{postData.platform_data?.name || 'N/A'}</span>
                        }
                      </div>

                      <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`}>
                        <label>Tipo de Material:</label>
                        {editModeInfo
                          ? <select className="info-edit-field" value={infoFormData.material_type} disabled={!infoFormData.platform} onChange={e => handleInfoInputChange('material_type', e.target.value)}>
                              <option value="">{infoFormData.platform ? 'Seleccionar tipo' : 'Elige una plataforma primero'}</option>
                              {materialesParaPlataforma(
                                platforms.find(p => String(p.id) === String(infoFormData.platform))?.name || postData.platform_data?.name,
                                infoFormData.material_type
                              ).map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                            </select>
                          : <span>{postData.material_type}</span>
                        }
                      </div>

                      <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`}>
                        <label>Influencer:</label>
                        {editModeInfo
                          ? <select className="info-edit-field" value={infoFormData.influencer} onChange={e => handleInfoInputChange('influencer', e.target.value)}>
                              <option value="">Seleccionar</option>
                              {Array.isArray(influencers) && influencers.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                            </select>
                          : <span>{postData.influencer_data?.name || 'N/A'}</span>
                        }
                      </div>

                      <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`}>
                        <label>Fecha de Publicación:</label>
                        {editModeInfo
                          ? <input className="info-edit-field" type="date" value={infoFormData.publication_date || ''} onChange={e => handleInfoInputChange('publication_date', e.target.value)} />
                          : <span>{formatDateOnly(postData.publication_date)}</span>
                        }
                      </div>

                      <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`}>
                        <label>Fecha de Validación:</label>
                        {editModeInfo
                          ? <input className="info-edit-field" type="date" value={infoFormData.validation_date || ''} onChange={e => handleInfoInputChange('validation_date', e.target.value)} />
                          : <span>{formatDateOnly(postData.validation_date)}</span>
                        }
                      </div>

                      <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`}>
                        <label>Desarrolla:</label>
                        {editModeInfo
                          ? <select className="info-edit-field" value={infoFormData.desarrolla} onChange={e => handleInfoInputChange('desarrolla', e.target.value)}>
                              <option value="">Seleccionar</option>
                              {Array.isArray(desarrollaList) && desarrollaList.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                            </select>
                          : <span style={{ backgroundColor: postData.desarrolla_color || '#6B7280', borderColor: postData.desarrolla_color || '#6B7280', color: 'white' }}>
                              {postData.desarrolla_name || 'N/A'}
                            </span>
                        }
                      </div>

                      <div className="info-item">
                        <label>Creado por:</label>
                        <span>{postData.creator_name || 'N/A'}</span>
                      </div>

                      {/* Etiqueta */}
                      {(postData.etiqueta || editModeInfo) && (
                        <div className={`info-item${editModeInfo ? ' info-item--edit' : ''}`}>
                          <label>Etiqueta:</label>
                          {editModeInfo
                            ? <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                <select
                                  className="info-edit-field"
                                  value={etiquetaSelectValue}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setEtiquetaSelectValue(val);
                                    if (val !== '__nueva__') {
                                      // Autocompletar con el color ya usado para esta etiqueta;
                                      // sin esto, editar/crear un post con una etiqueta existente
                                      // volvía a caer en el azul por defecto en vez de mantener
                                      // el color real de esa etiqueta.
                                      setInfoFormData(prev => ({
                                        ...prev,
                                        etiqueta: val,
                                        etiqueta_color: val ? (etiquetasColores[val] || '#3B82F6') : prev.etiqueta_color
                                      }));
                                    } else {
                                      setInfoFormData(prev => ({ ...prev, etiqueta: '', etiqueta_color: '#3B82F6' }));
                                    }
                                  }}
                                  style={{ flex: 1, minWidth: '120px' }}
                                >
                                  <option value="">Sin etiqueta</option>
                                  {infoFormData.etiqueta && !etiquetasDisponibles.includes(infoFormData.etiqueta) && (
                                    <option value={infoFormData.etiqueta}>{infoFormData.etiqueta}</option>
                                  )}
                                  {etiquetasDisponibles.map(et => <option key={et} value={et}>{et}</option>)}
                                </select>
                                {infoFormData.etiqueta && (
                                  <span style={{ padding: '2px 10px', borderRadius: '9999px', backgroundColor: infoFormData.etiqueta_color || '#3B82F6', color: '#fff', fontSize: '0.75rem', fontWeight: '700', flexShrink: 0 }}>
                                    {infoFormData.etiqueta}
                                  </span>
                                )}
                              </div>
                            : <span style={{ display: 'inline-block', padding: '3px 12px', borderRadius: '9999px', backgroundColor: postData.etiqueta_color || '#3B82F6', color: '#fff', fontSize: '0.85rem', fontWeight: '600' }}>
                                {postData.etiqueta}
                              </span>
                          }
                        </div>
                      )}

                      {postData.status === 'eliminado' && postData.deleted_by_name && (
                        <div className="info-item" style={{ backgroundColor: '#fee2e2', borderLeft: '4px solid #dc2626' }}>
                          <label style={{ color: '#991b1b' }}>Eliminado por:</label>
                          <span style={{ color: '#991b1b', fontWeight: '500' }}>{postData.deleted_by_name}</span>
                          {postData.deleted_at && (
                            <div style={{ fontSize: '0.875rem', color: '#991b1b', marginTop: '0.25rem' }}>
                              {new Date(postData.deleted_at).toLocaleString('es-ES')}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ── Editores Designados ──────────────────────── */}
                  <div className="editors-section">
                    <h3>Editores Designados</h3>
                    {editModeInfo ? (
                      <>
                        {editoresSeleccionados.length > 0 && (
                          <div style={{ marginBottom: '0.75rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                            {editoresSeleccionados.map(editorId => {
                              const editor = users.find(u => u.id === editorId);
                              if (!editor) return null;
                              const displayName = editor.first_name && editor.last_name ? `${editor.first_name} ${editor.last_name}` : editor.username;
                              return (
                                <div key={editorId} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 0.75rem', background: '#dbeafe', borderRadius: '12px', fontSize: '0.875rem' }}>
                                  <span style={{ fontWeight: '500', color: '#1e40af' }}>{displayName}</span>
                                  <button type="button" onClick={() => removeEditor(editorId)}
                                    style={{ background: 'none', border: 'none', color: '#1e40af', cursor: 'pointer', fontWeight: 'bold', padding: '0 2px' }}>✕</button>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <select
                          className="info-edit-field"
                          onChange={e => { addEditor(e.target.value); e.target.value = ''; }}
                          defaultValue=""
                          style={{ maxWidth: '280px', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '6px 10px', background: 'white' }}
                        >
                          <option value="">+ Agregar editor...</option>
                          {Array.isArray(users) && users.filter(u => !editoresSeleccionados.includes(u.id)).map(u => {
                            const name = u.first_name && u.last_name ? `${u.first_name} ${u.last_name}` : u.username;
                            return <option key={u.id} value={u.id}>{name}{u.email ? ` (${u.email})` : ''}</option>;
                          })}
                        </select>
                      </>
                    ) : (
                      postData.editores_data && postData.editores_data.length > 0
                        ? <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                            {postData.editores_data.map(editor => (
                              <span key={editor.id} style={{ padding: '0.25rem 0.65rem', background: '#dbeafe', borderRadius: '999px', fontSize: '0.75rem', fontWeight: '500', color: '#1e40af' }}>
                                {editor.username}
                              </span>
                            ))}
                          </div>
                        : <p style={{ color: '#6b7280', fontStyle: 'italic' }}>No hay editores asignados</p>
                    )}
                  </div>

                  {/* ── Brief ───────────────────────────────────── */}
                  <div className="brief-section">
                    <h3>Brief</h3>
                    {editModeInfo
                      ? <RichTextEditor initialContent={infoFormData.brief || ''} onUpdate={({ html }) => handleInfoInputChange('brief', html)} />
                      : postData.brief
                        ? <RichTextEditor initialContent={postData.brief} readOnly />
                        : <p style={{ color: '#9ca3af', fontSize: '14px' }}>Sin brief</p>
                    }

                    {/* Objetivos, Audiencia y Mensajes — solo lectura si tienen contenido, ocultos en edición */}
                    {(!editModeInfo && postData.brief_objectives) && (
                      <>
                        <h4>Objetivos</h4>
                        <RichTextEditor initialContent={postData.brief_objectives} readOnly />
                      </>
                    )}

                    {(!editModeInfo && postData.brief_target_audience) && (
                      <>
                        <h4>Audiencia Objetivo</h4>
                        <RichTextEditor initialContent={postData.brief_target_audience} readOnly />
                      </>
                    )}

                    {(!editModeInfo && postData.brief_key_messages) && (
                      <>
                        <h4>Mensajes Clave</h4>
                        <RichTextEditor initialContent={postData.brief_key_messages} readOnly />
                      </>
                    )}

                    {/* Archivos Adjuntos */}
                    <div style={{ marginTop: '1.25rem', paddingTop: '1rem', borderTop: '1px solid #f3f4f6' }}>
                      <h4 style={{ marginBottom: '0.6rem' }}>Archivos Adjuntos</h4>
                      {postData.info_attachments && postData.info_attachments.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.75rem' }}>
                          {postData.info_attachments.map(att => (
                            <div key={att.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 0.75rem', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px' }}>
                              <a href={att.file_url} target="_blank" rel="noopener noreferrer"
                                style={{ color: '#2563eb', fontSize: '0.875rem', textDecoration: 'none', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {att.file_name}
                                <span style={{ marginLeft: '0.5rem', color: '#9ca3af', fontSize: '0.75rem' }}>({(att.file_size / 1024).toFixed(1)} KB)</span>
                              </a>
                              {isManager && (
                                <button onClick={() => handleInfoAttachmentDelete(att.id)}
                                  style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '0 0.25rem', marginLeft: '0.5rem' }}>
                                  <i className="bi bi-x" />
                                </button>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p style={{ color: '#9ca3af', fontSize: '0.875rem', marginBottom: '0.75rem' }}>No hay archivos adjuntos</p>
                      )}
                      {isManager && (
                        <label
                          title={uploadingInfoAttachment ? 'Subiendo...' : 'Adjuntar archivos'}
                          style={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            width: '36px', height: '36px',
                            background: 'rgba(0,36,33,0.07)', color: 'var(--g-dark)',
                            borderRadius: '8px', cursor: uploadingInfoAttachment ? 'not-allowed' : 'pointer',
                            border: '1.5px solid rgba(0,36,33,0.15)', fontSize: '1.1rem',
                            opacity: uploadingInfoAttachment ? 0.5 : 1,
                            transition: 'background 0.15s'
                          }}
                        >
                          <input type="file" multiple style={{ display: 'none' }} disabled={uploadingInfoAttachment} onChange={e => handleInfoAttachmentUpload(e.target.files)} />
                          {uploadingInfoAttachment ? <i className="bi bi-hourglass-split" /> : <i className="bi bi-paperclip" />}
                        </label>
                      )}
                    </div>
                  </div>

                  {/* Guardar/Cancelar movidos al footer del modal */}
                </>

              </div>
            )}

            {activeTab === 'workflow' && (
              <div className="workflow-section">
                {/* Idea Creativa */}
                <div className="workflow-item">
                  <div className="workflow-header">
                    <div className="workflow-title">
                      <div className={`workflow-status ${postData.creative_idea_approved ? 'approved' : 'pending'}`} />
                      <h4>Idea Creativa</h4>
                    </div>
                    {!postData.creative_idea_approved && postData.editores_data?.length > 0 && (
                      <button
                        onClick={() => handleEditToggle('creative_idea')}
                        className="cal-icon-btn"
                        title={editMode.creative_idea ? 'Cancelar edición' : 'Editar'}
                      >
                        <i className={editMode.creative_idea ? 'bi bi-x-lg' : 'bi bi-pencil'} />
                      </button>
                    )}
                  </div>

                  {editMode.creative_idea ? (
                    <div className="edit-section">
                      <RichTextEditor
                        initialContent={formData.creative_idea}
                        onUpdate={({ html }) => handleInputChange('creative_idea', html)}
                        placeholder="Describe la idea creativa..."
                      />
                      {/* Guardar movido al footer del modal */}
                    </div>
                  ) : (
                    <>
                      {postData.creative_idea ? (
                        <RichTextEditor initialContent={postData.creative_idea} readOnly />
                      ) : (
                        <p className="empty">
                          {postData.editores_data?.length > 0 ? 'Pendiente' : 'Debes asignar editores primero'}
                        </p>
                      )}
                      {postData.creative_idea_approved && (
                        <span className="approved-by">
                          Aprobado por: {postData.creative_idea_approved_by_name}
                        </span>
                      )}
                      {postData.creative_idea && !postData.creative_idea_approved && (
                        <div className="approval-buttons">
                          <button
                            onClick={() => handleApproval('creative_idea', 'approved')}
                            className="btn-approve"
                            disabled={!canApproveCreativeIdea || approvingKey === 'creative_idea-approved'}
                            title={!canApproveCreativeIdea ? 'No tienes permiso para aprobar ideas creativas' : 'Aprobar idea creativa'}
                            style={{
                              opacity: canApproveCreativeIdea ? 1 : 0.5,
                              cursor: canApproveCreativeIdea ? 'pointer' : 'not-allowed'
                            }}
                          >
                            {approvingKey === 'creative_idea-approved' ? 'Aprobando...' : 'Aprobar'}
                          </button>
                          <button
                            onClick={() => {
                              const notes = prompt('Notas de rechazo:');
                              if (notes) handleApproval('creative_idea', 'rejected', notes);
                            }}
                            className="btn-reject"
                            disabled={!canApproveCreativeIdea || approvingKey === 'creative_idea-rejected'}
                            title={!canApproveCreativeIdea ? 'No tienes permiso para rechazar ideas creativas' : 'Rechazar idea creativa'}
                            style={{
                              opacity: canApproveCreativeIdea ? 1 : 0.5,
                              cursor: canApproveCreativeIdea ? 'pointer' : 'not-allowed'
                            }}
                          >
                            {approvingKey === 'creative_idea-rejected' ? 'Rechazando...' : 'Rechazar'}
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Copy */}
                <div className="workflow-item">
                  <div className="workflow-header">
                    <div className="workflow-title">
                      <div className={`workflow-status ${postData.copy_approved ? 'approved' : 'pending'}`} />
                      <h4>Copy</h4>
                    </div>
                    {!postData.copy_approved && postData.editores_data?.length > 0 && (
                      <button
                        onClick={() => handleEditToggle('copy')}
                        className="cal-icon-btn"
                        title={editMode.copy ? 'Cancelar edición' : 'Editar'}
                      >
                        <i className={editMode.copy ? 'bi bi-x-lg' : 'bi bi-pencil'} />
                      </button>
                    )}
                  </div>

                  {editMode.copy ? (
                    <div className="edit-section">
                      <RichTextEditor
                        initialContent={formData.copy}
                        onUpdate={({ html }) => handleInputChange('copy', html)}
                        placeholder="Escribe el copy..."
                      />
                      <input
                        type="text"
                        value={formData.hashtags}
                        onChange={(e) => handleInputChange('hashtags', e.target.value)}
                        placeholder="#hashtags"
                      />
                      <input
                        type="text"
                        value={formData.mentions}
                        onChange={(e) => handleInputChange('mentions', e.target.value)}
                        placeholder="@menciones"
                      />

                      {/* Guardar movido al footer del modal */}
                    </div>
                  ) : (
                    <>
                      {postData.copy ? (
                        <>
                          <RichTextEditor initialContent={postData.copy} readOnly />
                          {postData.hashtags && (
                            <p className="meta-info"><strong>Hashtags:</strong> {postData.hashtags}</p>
                          )}
                          {postData.mentions && (
                            <p className="meta-info"><strong>@ Menciones:</strong> {postData.mentions}</p>
                          )}
                        </>
                      ) : (
                        <p className="empty">
                          {postData.editores_data?.length > 0 ? 'Pendiente' : 'Debes asignar editores primero'}
                        </p>
                      )}
                      {postData.copy_approved && (
                        <span className="approved-by">
                          Aprobado por: {postData.copy_approved_by_name}
                        </span>
                      )}
                      {postData.copy && !postData.copy_approved && (
                        <div className="approval-buttons">
                          <button
                            onClick={() => handleApproval('copy', 'approved')}
                            className="btn-approve"
                            disabled={!canApproveCopy || approvingKey === 'copy-approved'}
                            title={!canApproveCopy ? 'No tienes permiso para aprobar copy' : 'Aprobar copy'}
                            style={{
                              opacity: canApproveCopy ? 1 : 0.5,
                              cursor: canApproveCopy ? 'pointer' : 'not-allowed'
                            }}
                          >
                            {approvingKey === 'copy-approved' ? 'Aprobando...' : 'Aprobar'}
                          </button>
                          <button
                            onClick={() => {
                              const notes = prompt('Notas de rechazo:');
                              if (notes) handleApproval('copy', 'rejected', notes);
                            }}
                            className="btn-reject"
                            disabled={!canApproveCopy || approvingKey === 'copy-rejected'}
                            title={!canApproveCopy ? 'No tienes permiso para rechazar copy' : 'Rechazar copy'}
                            style={{
                              opacity: canApproveCopy ? 1 : 0.5,
                              cursor: canApproveCopy ? 'pointer' : 'not-allowed'
                            }}
                          >
                            {approvingKey === 'copy-rejected' ? 'Rechazando...' : 'Rechazar'}
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Aprobación Final */}
                <div className="workflow-item workflow-item--flat">
                  <div className="workflow-header">
                    <div className="workflow-title">
                      <div className={`workflow-status ${postData.final_approved ? 'approved' : 'pending'}`} />
                      <h4>Aprobación Final</h4>
                    </div>
                  </div>

                  {postData.final_approved ? (
                    <>
                      <p className="approved">Post aprobado y listo para publicar</p>
                      <span className="approved-by">
                        Aprobado por: {postData.final_approved_by_name}
                      </span>
                    </>
                  ) : (
                    <div className="approval-buttons">
                      <button
                        onClick={() => handleApproval('final', 'approved')}
                        className="btn-approve-final"
                        disabled={!canGiveFinalApproval() || approvingKey === 'final-approved'}
                        title={!canGiveFinalApproval() ? 'Falta: idea creativa, copy y/o al menos un medio aprobado' : 'Dar aprobación final'}
                        style={{ opacity: canGiveFinalApproval() ? 1 : 0.45, cursor: canGiveFinalApproval() ? 'pointer' : 'not-allowed' }}
                      >
                        {approvingKey === 'final-approved' ? 'Aprobando...' : 'Aprobar'}
                      </button>
                      <button
                        onClick={() => {
                          const notes = prompt('Motivo del rechazo:');
                          if (notes) handleApproval('final', 'rejected', notes);
                        }}
                        className="btn-reject"
                        disabled={!canGiveFinalApproval() || approvingKey === 'final-rejected'}
                        style={{ opacity: canGiveFinalApproval() ? 1 : 0.45, cursor: canGiveFinalApproval() ? 'pointer' : 'not-allowed' }}
                      >
                        {approvingKey === 'final-rejected' ? 'Rechazando...' : 'Rechazar'}
                      </button>
                    </div>
                  )}
                </div>

                {/* Aprobación Cliente — solo si el post tiene etiqueta y corresponde mostrarla */}
                {postData.etiqueta && (postData.final_approved || postData.client_approved) && (
                  <div className="workflow-item workflow-item--flat">
                    <div className="workflow-header">
                      <div className="workflow-title">
                        <div className={`workflow-status ${postData.client_approved ? 'approved' : 'pending'}`} />
                        <h4>Aprobación Cliente</h4>
                      </div>
                    </div>

                    {postData.client_approved ? (
                      <>
                        <p className="approved">Aprobado por el cliente</p>
                        <span className="approved-by">
                          Aprobado por: {postData.client_approved_by_name}
                        </span>
                      </>
                    ) : isClientApprover ? (
                      <div className="approval-buttons">
                        <button
                          onClick={() => {
                            const notes = prompt('Comentario del cliente (opcional):');
                            if (notes === null) return; // cancelado
                            handleApproval('client', 'approved', notes);
                          }}
                          className="btn-approve-final"
                          disabled={approvingKey === 'client-approved'}
                          style={{ background: '#0ea5e9' }}
                        >
                          {approvingKey === 'client-approved' ? 'Aprobando...' : 'Dar Aprobación Cliente'}
                        </button>
                        <button
                          onClick={() => {
                            const notes = prompt('Motivo del rechazo del cliente:');
                            if (notes) handleApproval('client', 'rejected', notes);
                          }}
                          className="btn-reject"
                          disabled={approvingKey === 'client-rejected'}
                        >
                          {approvingKey === 'client-rejected' ? 'Rechazando...' : 'Rechazar'}
                        </button>
                      </div>
                    ) : (
                      <p className="empty">Pendiente de aprobación del cliente</p>
                    )}
                  </div>
                )}
            </div>
            )}

            {activeTab === 'media' && (
            <div className="media-section">
              {/* Upload Zone */}
              {postData.editores_data?.length > 0 && (
                <div className="media-upload-zone">
                  <input
                    type="file"
                    id="media-upload"
                    accept="image/*,video/*"
                    multiple
                    onChange={handleMediaUpload}
                    style={{ display: 'none' }}
                    disabled={uploadingMedia}
                  />
                  <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
                    <label htmlFor="media-upload" className="btn-upload" title="Subir archivos">
                      {uploadingMedia
                        ? <><i className="bi bi-hourglass-split" /> {uploadProgress || 'Subiendo...'}</>
                        : <i className="bi bi-upload" />
                      }
                    </label>
                    {pendingMediaIds.length > 0 && (
                      <button
                        onClick={handleSendToApproval}
                        disabled={sendingNotification}
                        className="btn-send-approval"
                      >
                        {sendingNotification
                          ? '⏳ Enviando...'
                          : `📩 Enviar a Aprobación (${pendingMediaIds.length})`}
                      </button>
                    )}
                  </div>
                  <p style={{ marginTop: '0.5rem', color: '#6b7280', fontSize: '0.875rem' }}>
                    Puedes seleccionar múltiples archivos a la vez. Cuando termines de subir, presiona "Enviar a Aprobación".
                  </p>
                </div>
              )}

              {/* Media Grid */}
              {postData.media_files && postData.media_files.length > 0 ? (
                <>
                  {/* Resumen de aprobaciones */}
                  <div style={{
                    padding: '1rem',
                    background: '#f9fafb',
                    borderRadius: '0.5rem',
                    marginBottom: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <div>
                      <strong style={{ fontSize: '0.875rem', color: '#374151' }}>
                        Estado de Medios:
                      </strong>
                      <span style={{ marginLeft: '0.5rem', color: '#6b7280' }}>
                        {postData.media_files.filter(m => m.approved_by_name).length} de {postData.media_files.length} revisados
                        {' '}({postData.media_files.filter(m => m.approved).length} <i className="bi bi-check-circle-fill" style={{ color: '#10b981' }} />,
                        {' '}{postData.media_files.filter(m => !m.approved && m.approved_by_name).length} <i className="bi bi-x-circle-fill" style={{ color: '#ef4444' }} />)
                      </span>
                    </div>
                    {allMediaReviewed() && postData.media_files.length > 0 && (
                      <span style={{
                        padding: '0.25rem 0.75rem',
                        background: '#10b981',
                        color: 'white',
                        borderRadius: '1rem',
                        fontSize: '0.875rem',
                        fontWeight: '600'
                      }}>
                        <i className="bi bi-check-circle-fill" /> Todos revisados
                      </span>
                    )}
                  </div>

                  {/* Grid de archivos */}
                  <div className="media-grid">
                    {postData.media_files.map((media) => (
                      <div key={media.id} className="media-item-card">
                        {/* Preview del archivo */}
                        <div className="media-preview">
                          {media.file_type === 'image' ? (
                            <img
                              src={media.file_url}
                              alt="Media"
                              style={{ cursor: 'zoom-in' }}
                              onClick={() => setLightboxImage(media.file_url)}
                              title="Clic para ampliar"
                            />
                          ) : media.file_type === 'video' ? (
                            <video src={media.file_url} controls />
                          ) : (
                            <div className="file-placeholder">
                              📄 {media.file_type}
                            </div>
                          )}
                        </div>

                        {/* Info y acciones */}
                        <div className="media-info">
                          <div className="media-metadata">
                            <div className="media-metadata-header">
                              <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                                Subido por: {media.uploaded_by_name}
                              </span>
                              <button
                                className="btn-download-media"
                                title="Descargar archivo"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  contentService.downloadMedia(media.id);
                                }}
                              >
                                <i className="bi bi-download" />
                              </button>
                            </div>
                            <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                              {new Date(media.uploaded_at).toLocaleDateString('es-CL')}
                            </span>
                          </div>

                          {/* Estado de aprobación */}
                          {media.approved ? (
                            // Medio aprobado - solo mostrar estado
                            <div className="approval-status approved">
                              <span className="status-badge-small" style={{ background: '#10b981' }}>
                                <i className="bi bi-check-circle-fill" /> Aprobado
                              </span>
                              <span style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>
                                por {media.approved_by_name}
                              </span>
                            </div>
                          ) : media.approved_by_name ? (
                            // Medio rechazado - solo mostrar estado
                            <div className="approval-status rejected">
                              <span className="status-badge-small" style={{ background: '#ef4444' }}>
                                <i className="bi bi-x-circle-fill" /> Rechazado
                              </span>
                              <span style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>
                                por {media.approved_by_name}
                              </span>
                            </div>
                          ) : postData.user_can_approve_media ? (
                            // Usuario puede aprobar - mostrar botones
                            <div className="approval-actions">
                              <button
                                onClick={() => handleMediaApproval(media.id, 'approved')}
                                className="btn-approve-media"
                                title="Aprobar este archivo"
                                disabled={!!approvingMedia}
                                style={{ opacity: approvingMedia ? 0.6 : 1, cursor: approvingMedia ? 'not-allowed' : 'pointer' }}
                              >
                                {approvingMedia?.id === media.id && approvingMedia?.action === 'approved'
                                  ? <><i className="bi bi-hourglass-split" /> Aprobando...</>
                                  : <><i className="bi bi-check-circle-fill" /> Aprobar</>
                                }
                              </button>
                              <button
                                onClick={() => handleMediaApproval(media.id, 'rejected')}
                                className="btn-reject-media"
                                title="Rechazar este archivo"
                                disabled={!!approvingMedia}
                                style={{ opacity: approvingMedia ? 0.6 : 1, cursor: approvingMedia ? 'not-allowed' : 'pointer' }}
                              >
                                {approvingMedia?.id === media.id && approvingMedia?.action === 'rejected'
                                  ? <><i className="bi bi-hourglass-split" /> Rechazando...</>
                                  : <><i className="bi bi-x-circle-fill" /> Rechazar</>
                                }
                              </button>
                            </div>
                          ) : (
                            // Usuario no puede aprobar - mostrar estado pendiente
                            <div className="approval-status pending">
                              <span className="status-badge-small" style={{ background: '#f59e0b' }}>
                                ⏳ Pendiente de revisión
                              </span>
                            </div>
                          )}

                          {/* Botón eliminar (solo para editores que subieron el archivo y si NO está aprobado) */}
                          {postData.editores_data?.some(editor => editor.id === media.uploaded_by) && !media.approved && (
                            <button
                              onClick={() => handleDeleteMedia(media.id)}
                              className="btn-delete-media-small"
                              title="Eliminar archivo"
                            >
                              <i className="bi bi-trash" /> Eliminar
                            </button>
                          )}

                          {/* Botón eliminar para contenido aprobado (solo admin) */}
                          {media.approved && authService.getUser()?.username === 'admin' && (
                            <button
                              onClick={() => handleDeleteMedia(media.id)}
                              className="btn-delete-media-small"
                              title="Eliminar archivo aprobado (solo admin)"
                            >
                              <i className="bi bi-trash" /> Eliminar
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="empty-state">
                  <p>No hay medios cargados aún</p>
                </div>
              )}
            </div>
          )}

            {activeTab === 'comments' && (
            <CommentsSection postId={postId} users={users} />
          )}

            {activeTab === 'tasks' && (
              <div style={{ padding: '1.5rem' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '1.5rem'
                }}>
                  <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600', color: '#111827' }}>
                    Tareas del Post ({tareasDelPost.length})
                  </h3>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                  }}>
                    {/* Badge de tiempo total */}
                    {tareasDelPost.length > 0 && (() => {
                      const totalSeconds = tareasDelPost.reduce((sum, tarea) => sum + (tarea.total_time_seconds || 0), 0);
                      return (
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          padding: '0.5rem 1rem',
                          background: totalSeconds > 0 ? '#dbeafe' : '#f3f4f6',
                          color: totalSeconds > 0 ? '#1e40af' : '#6b7280',
                          borderRadius: '9999px',
                          fontSize: '0.875rem',
                          fontWeight: '600'
                        }}>
                          <i className="fas fa-clock"></i>
                          <span>Total: {formatTime(totalSeconds)}</span>
                        </div>
                      );
                    })()}

                    <button
                      onClick={() => {
                        setTareaEditando(null);
                        setShowTareaModal(true);
                      }}
                      style={{
                        padding: '0.75rem 1.5rem',
                        background: 'linear-gradient(135deg, #102826 0%, #69B32D 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.5rem',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        transition: 'all 0.2s'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      ➕ Nueva Tarea
                    </button>
                  </div>
                </div>

                {loadingTareas ? (
                  <div style={{
                    background: '#f9fafb',
                    borderRadius: '0.5rem',
                    padding: '2rem',
                    textAlign: 'center',
                    color: '#6b7280'
                  }}>
                    <Loading fullScreen={false} size="sm" mensaje="Cargando tareas" />
                  </div>
                ) : tareasDelPost.length === 0 ? (
                  <div style={{
                    background: '#f9fafb',
                    borderRadius: '0.5rem',
                    padding: '2rem',
                    textAlign: 'center',
                    color: '#6b7280'
                  }}>
                    <p style={{ margin: 0, fontSize: '0.875rem' }}>
                      No hay tareas asociadas a este post
                    </p>
                  </div>
                ) : (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem'
                  }}>
                    {tareasDelPost.map(tarea => (
                      <div
                        key={tarea.id}
                        onClick={() => {
                          setTareaEditando(tarea);
                          setShowTareaModal(true);
                        }}
                        style={{
                          background: 'white',
                          border: '1px solid #e5e7eb',
                          borderRadius: '0.5rem',
                          padding: '1rem',
                          cursor: 'pointer',
                          transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                          e.currentTarget.style.borderColor = '#3b82f6';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.boxShadow = 'none';
                          e.currentTarget.style.borderColor = '#e5e7eb';
                        }}
                      >
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          marginBottom: '0.5rem'
                        }}>
                          <h4 style={{
                            margin: 0,
                            fontSize: '1rem',
                            fontWeight: '600',
                            color: '#111827'
                          }}>
                            {tarea.nombre_tarea}
                          </h4>
                          {tarea.status_nombre && (
                            <span style={{
                              padding: '0.25rem 0.75rem',
                              borderRadius: '12px',
                              fontSize: '0.75rem',
                              fontWeight: '600',
                              background: tarea.status_color || '#f3f4f6',
                              color: '#374151'
                            }}>
                              {tarea.status_nombre}
                            </span>
                          )}
                        </div>

                        {tarea.descripcion && (
                          <p style={{
                            margin: '0.5rem 0',
                            fontSize: '0.875rem',
                            color: '#6b7280',
                            lineHeight: '1.5'
                          }}>
                            {tarea.descripcion}
                          </p>
                        )}

                        <div style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '0.75rem',
                          marginTop: '0.75rem',
                          fontSize: '0.75rem',
                          color: '#6b7280'
                        }}>
                          {tarea.asignado_a_nombre && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                              <span>👤</span>
                              <span>{tarea.asignado_a_nombre}</span>
                            </div>
                          )}
                          {tarea.tablero_nombre && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                              <span>📋</span>
                              <span>{tarea.tablero_nombre}</span>
                            </div>
                          )}
                          {tarea.fecha_entrega && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                              <span>📅</span>
                              <span>{
                                (() => {
                                  // 🆕 Parsear fecha YYYY-MM-DD correctamente sin problemas de timezone
                                  const [year, month, day] = tarea.fecha_entrega.split('-').map(Number);
                                  const date = new Date(year, month - 1, day);
                                  return date.toLocaleDateString('es-CL');
                                })()
                              }</span>
                            </div>
                          )}
                          {/* Tiempo total */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            marginLeft: 'auto',
                            padding: '0.25rem 0.75rem',
                            background: tarea.total_time_seconds > 0 ? '#dbeafe' : '#f3f4f6',
                            color: tarea.total_time_seconds > 0 ? '#1e40af' : '#6b7280',
                            borderRadius: '12px',
                            fontWeight: '600',
                            fontSize: '0.8rem'
                          }}>
                            <i className="fas fa-clock"></i>
                            <span>{formatTime(tarea.total_time_seconds || 0)}</span>
                          </div>
                        </div>

                        {/* Botones de acción */}
                        <div style={{
                          marginTop: '0.75rem',
                          paddingTop: '0.75rem',
                          borderTop: '1px solid #e5e7eb',
                          display: 'flex',
                          gap: '0.5rem'
                        }}>
                          <button
                            onClick={(e) => {
                              e.stopPropagation(); // Evitar que se abra el modal de edición
                              setSelectedTaskForTime(tarea);
                              setShowManualTimeForm(true);
                            }}
                            style={{
                              padding: '0.5rem 1rem',
                              background: 'linear-gradient(135deg, #102826, #69B32D)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem'
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <i className="fas fa-clock"></i> Agregar Tiempo Manual
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteTarea(tarea.id);
                            }}
                            style={{
                              padding: '0.5rem 1rem',
                              background: '#ef4444',
                              color: 'white',
                              border: 'none',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem'
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.background = '#dc2626';
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.background = '#ef4444';
                            }}
                          >
                            🗑️ Eliminar Tarea
                          </button>
                        </div>

                        {/* Formulario de entrada manual de tiempo - dentro del mapa */}
                        {showManualTimeForm && selectedTaskForTime && selectedTaskForTime.id === tarea.id && (
                          <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              background: '#f0f9ff',
                              border: '2px solid #3b82f6',
                              borderRadius: '8px',
                              padding: '1.5rem',
                              marginTop: '1rem'
                            }}>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '1rem'
                            }}>
                              <h4 style={{
                                margin: 0,
                                color: '#1e40af',
                                fontSize: '1rem',
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem'
                              }}>
                                <i className="fas fa-clock"></i> Agregar Tiempo Manual
                              </h4>
                              <button
                                onClick={() => {
                                  setShowManualTimeForm(false);
                                  setSelectedTaskForTime(null);
                                  setManualTimeForm({
                                    fecha: new Date().toISOString().split('T')[0],
                                    minutos: '',
                                    notas: ''
                                  });
                                }}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  fontSize: '1.5rem',
                                  cursor: 'pointer',
                                  color: '#6b7280',
                                  padding: '0',
                                  lineHeight: '1'
                                }}
                              >
                                ×
                              </button>
                            </div>

                            <form onSubmit={handleAddManualTime}>
                              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                                <div>
                                  <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '600'
                                  }}>
                                    Fecha
                                  </label>
                                  <input
                                    type="date"
                                    value={manualTimeForm.fecha}
                                    onChange={(e) => setManualTimeForm({ ...manualTimeForm, fecha: e.target.value })}
                                    required
                                    max={new Date().toISOString().split('T')[0]}
                                    style={{
                                      width: '100%',
                                      padding: '0.5rem',
                                      border: '1px solid #d1d5db',
                                      borderRadius: '6px',
                                      fontSize: '0.875rem'
                                    }}
                                  />
                                </div>

                                <div>
                                  <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '600'
                                  }}>
                                    Tiempo (minutos)
                                  </label>
                                  <input
                                    type="number"
                                    min="1"
                                    value={manualTimeForm.minutos}
                                    onChange={(e) => setManualTimeForm({ ...manualTimeForm, minutos: e.target.value })}
                                    required
                                    placeholder="ej: 30"
                                    style={{
                                      width: '100%',
                                      padding: '0.5rem',
                                      border: '1px solid #d1d5db',
                                      borderRadius: '6px',
                                      fontSize: '0.875rem'
                                    }}
                                  />
                                </div>
                              </div>

                              <div style={{ marginBottom: '1rem' }}>
                                <label style={{
                                  display: 'block',
                                  marginBottom: '0.5rem',
                                  color: '#374151',
                                  fontSize: '0.875rem',
                                  fontWeight: '600'
                                }}>
                                  Notas (opcional)
                                </label>
                                <textarea
                                  value={manualTimeForm.notas}
                                  onChange={(e) => setManualTimeForm({ ...manualTimeForm, notas: e.target.value })}
                                  placeholder="Describe en qué trabajaste..."
                                  rows="3"
                                  style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '0.875rem',
                                    resize: 'vertical'
                                  }}
                                />
                              </div>

                              <div style={{
                                display: 'flex',
                                gap: '0.75rem',
                                justifyContent: 'flex-end'
                              }}>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setShowManualTimeForm(false);
                                    setSelectedTaskForTime(null);
                                    setManualTimeForm({
                                      fecha: new Date().toISOString().split('T')[0],
                                      minutos: '',
                                      notas: ''
                                    });
                                  }}
                                  style={{
                                    padding: '0.5rem 1.5rem',
                                    background: '#6b7280',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '0.875rem',
                                    fontWeight: '600',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Cancelar
                                </button>
                                <button
                                  type="submit"
                                  style={{
                                    padding: '0.5rem 1.5rem',
                                    background: 'linear-gradient(135deg, #102826, #69B32D)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '0.875rem',
                                    fontWeight: '600',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Guardar Tiempo
                                </button>
                              </div>
                            </form>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeTab === 'patrocinio' && (
            <PostPatrocinio
              ref={patrocinioRef}
              postData={postData}
              onUpdate={handlePatrocinioUpdate}
              canEdit={true}
              onEditingChange={setEditModePatrocinio}
            />
          )}

            {activeTab === 'ediciones' && (
              <div className="ediciones-section">
                {postData.edit_history && postData.edit_history.length > 0 ? (
                  <table className="edit-history-table">
                    <thead>
                      <tr>
                        <th>Campo</th>
                        <th>Valor anterior</th>
                        <th>Valor nuevo</th>
                        <th>Usuario</th>
                        <th>Fecha y hora</th>
                        <th>Pestaña</th>
                      </tr>
                    </thead>
                    <tbody>
                      {postData.edit_history.flatMap((edit, editIndex) =>
                        Object.entries(edit.changes || {}).map(([field, change]) => (
                          <tr key={`${editIndex}-${field}`}>
                            <td className="eh-field">{change.label || field}</td>
                            <td className="eh-old">{stripHtmlValue(change.old) || 'N/A'}</td>
                            <td className="eh-new">{stripHtmlValue(change.new) || 'N/A'}</td>
                            <td className="eh-user">{edit.user_name || 'Usuario'}</td>
                            <td className="eh-date">
                              {new Date(edit.timestamp).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            </td>
                            <td className="eh-tab">
                              <span className="eh-tab-pill">{getFieldTabLabel(field)}</span>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                ) : (
                  <p className="empty">No hay ediciones registradas todavía</p>
                )}
              </div>
            )}
          </div>

          {/* Footer — muestra Guardar/Cancelar cuando hay edición activa */}
          <div className="detail-footer">
            {editModeInfo ? (
              <>
                <button onClick={handleInfoEditToggle} className="g-btn g-btn-secondary">Cancelar</button>
                <button onClick={handleSubmitInfo} className="g-btn g-btn-primary">Guardar</button>
              </>
            ) : editMode.creative_idea ? (
              <>
                <button onClick={() => handleEditToggle('creative_idea')} className="g-btn g-btn-secondary">Cancelar</button>
                <button onClick={handleSubmitCreativeIdea} className="g-btn g-btn-primary">Guardar</button>
              </>
            ) : editMode.copy ? (
              <>
                <button onClick={() => handleEditToggle('copy')} className="g-btn g-btn-secondary">Cancelar</button>
                <button onClick={handleSubmitCopy} className="g-btn g-btn-primary">Guardar</button>
              </>
            ) : editModePatrocinio ? (
              <>
                <button onClick={() => patrocinioRef.current?.triggerCancel()} className="g-btn g-btn-secondary">Cancelar</button>
                <button onClick={() => patrocinioRef.current?.triggerSave()} className="g-btn g-btn-primary">Guardar</button>
              </>
            ) : (
              <button onClick={onClose} className="g-btn g-btn-secondary">Cerrar</button>
            )}
          </div>
        </div>

        <PostPreviewPanel
          platformName={
            editModeInfo
              ? (platforms.find(p => String(p.id) === String(infoFormData.platform))?.name || postData.platform_data?.name)
              : postData.platform_data?.name
          }
          accountName={postData.influencer_data?.instagram_username || postData.influencer_data?.name}
          copyHtml={editMode.copy ? formData.copy : postData.copy}
          hashtags={editMode.copy ? formData.hashtags : postData.hashtags}
          mentions={editMode.copy ? formData.mentions : postData.mentions}
          mediaFiles={postData.media_files}
          materialType={editModeInfo ? infoFormData.material_type : postData.material_type}
        />
        </div>
        </div>
      </div>

      {/* Modal de Tarea */}
      {showTareaModal && (
        <TareaModal
          tarea={tareaEditando}
          clientes={clientes.map(c => ({ id: c.id, name: c.nombre }))}
          usuarios={users}
          tableros={tableros}
          proyectos={proyectos}
          postId={postId}
          clienteId={postData?.cliente}
          proyectoId={postData?.proyecto}
          partidaPresupuestoId={postData?.partida_presupuesto}
          onClose={() => {
            setShowTareaModal(false);
            setTareaEditando(null);
          }}
          onSave={handleSaveTarea}
        />
      )}

      {/* Lightbox de imagen */}
      {lightboxImage && (
        <div
          onClick={() => setLightboxImage(null)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            cursor: 'zoom-out',
          }}
        >
          <button
            onClick={() => setLightboxImage(null)}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1.25rem',
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '50%',
              width: '2.25rem',
              height: '2.25rem',
              color: 'white',
              fontSize: '1.25rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 1,
            }}
            title="Cerrar"
          >
            ×
          </button>
          <img
            src={lightboxImage}
            alt="Previsualización"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
              borderRadius: '8px',
              boxShadow: '0 25px 60px rgba(0,0,0,0.5)',
              cursor: 'default',
            }}
          />
        </div>
      )}
    </>
  );
};

export default PostDetailModal;